// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"help"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M11.9957 16.4502V15.0715C11.9957 13.3983 13.4915 12.1047 14.8057 11.0692C15.8619 10.2371 16.54 8.94656 16.54 7.49766C16.54 4.98792 14.5054 2.95337 11.9957 2.95337C10.0171 2.95337 8.3338 4.2179 7.70996 5.98289M11.9955 19.9941H12.0014","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-help')
export default class HelpIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'help',
    }
  }
}
